<div class="flex flex-col items-center justify-center text-center w-full flex-grow">
  <span class="text-sm text-default-gray" [innerHTML]="'components.login_phone.ask_security_code' | translate: { userContact: userContact }"></span>
  <div class="flex flex-col justify-center items-center p-2 w-full">
    <div class="w-full py-4">
      <ng-otp-input (onInputChange)="onOTPChange($event)" [config]="OTPConfig"></ng-otp-input>
      <input type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        pattern="\d{6}"
        [(ngModel)]="verificationCode"
        required
        hidden
        >
    </div>
    <button mat-raised-button class="w-full m-2" color="accent" [disabled]="!validOTP || submitting" (click)="submit()">Continuar</button>
  </div>
  <div class="flex flex-col  gap-1 w-full">
    <span class="text-sm text-error">{{ 'components.login_phone.resend_code_question' | translate }}</span>
    <span *ngIf="resendDisabled" class="w-full text-sm text-light-gray">{{ 'components.login_phone.resend_code_timer' | translate: { resendTimer: resendTimer } }}</span>
    <div *ngIf="!resendDisabled" class="flex flex-col pt-5 gap-2">
      <span *ngIf="!isEmailContact" class="hover:cursor-pointer w-full underline font-medium" color="primary" (click)="resendCode(otpChannels.SMS)">{{ 'components.login_phone.resend_code_sms' | translate }}</span>
      <span *ngIf="!isEmailContact" class="hover:cursor-pointer w-full underline font-medium" color="primary" (click)="resendCode(otpChannels.WHATSAPP)">{{ 'components.login_phone.resend_code_whatsapp' | translate }}</span>
      <span *ngIf="isEmailContact" class="hover:cursor-pointer w-full underline font-medium" color="primary" (click)="resendCode(otpChannels.EMAIL)">{{ 'components.login_phone.resend_code_email' | translate }}</span>
    </div>
  </div>
</div>
